import { Box } from '@chakra-ui/react';
import type { SingleValue } from 'react-select';

import { StyledPlotSelect } from '../StyledPlotSelect';

type NumOfNodesOption = {
  value: number;
  label: string;
};

const numOfNodeOptions: NumOfNodesOption[] = [
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 20, label: '20' },
  { value: 25, label: '25' },
  { value: 30, label: '30' },
];

type SankeyFooterProps = {
  numOfNodes: number;
  onNumOfNodesChange: (value: number) => void;
};

export const SankeyFooter = ({
  numOfNodes,
  onNumOfNodesChange,
}: SankeyFooterProps) => {
  const numOfNodesValue: NumOfNodesOption | null = {
    value: numOfNodes,
    label: `${numOfNodes}`,
  };

  const onChange = (value: SingleValue<NumOfNodesOption>) => {
    if (value) {
      onNumOfNodesChange(value.value);
    }
  };

  return (
    <Box position="absolute" right="0" bottom="0">
      <StyledPlotSelect
        value={numOfNodesValue}
        onChange={onChange}
        options={numOfNodeOptions}
        menuPlacement="top"
        getOptionLabel={(option) => `Show ${option.label}`}
      />
    </Box>
  );
};
